import { Expose, Type } from "class-transformer";
import { IsString, ValidateNested } from "class-validator";

export class MailHistoryContent {
  @IsString()
  @Expose()
  content!: string;

  @Type(() => MailHistoryAttachment)
  @ValidateNested()
  @Expose()
  attachments!: Array<MailHistoryAttachment>;
}

export class MailHistoryAttachment {
  @IsString()
  @Expose()
  id!: string;

  @IsString()
  @Expose()
  name!: string;
}
